module.exports = __webpack_public_path__ + "static/media/phone-slash.f8fd9372.svg";